import { clearSessionState } from '@/actions/clearSessionState';
import { usePublishEvent } from '@/analytics/usePublishEvent';
import { SignInApiClient } from '@/api/sign-in';
import { useThreatMetrix } from '@/hooks/useThreatMetrix';
import { CommonRoutes, SignInRoutes, StepUpRoutes } from '@/Routes';
import { UIFlow, useSessionStore } from '@/store/session';
import { useSignInStore } from '@/store/signInStore';
import { useRouter } from 'next/navigation';

export type FinalizeOptions = {
  extraData?: Record<string, unknown>;
};

export const useLoginFinalize = () => {
  const router = useRouter();
  const publishEvent = usePublishEvent();

  const tmxProfile = useThreatMetrix();

  const uiFlow = useSessionStore((s) => s.uiFlow);

  const updateSession = useSignInStore((s) => s.updateSession);

  return async (elementId: string, options?: FinalizeOptions) => {
    const sessionId = await tmxProfile();
    const response = await SignInApiClient.finalize(sessionId);

    if (response.success) {
      publishEvent('SuccessfulLogin', elementId, {
        asurionId: response.asurionId || '',
        ...options?.extraData,
        Acr: response.acr,
      });

      const redirectUrl = response.url;

      if (response.promptPasswordCreation) {
        updateSession({ redirectUrl });
        router.push(SignInRoutes.CREATE_PASSWORD);
      } else if (
        uiFlow === UIFlow.SignInStepUp ||
        uiFlow === UIFlow.PasswordResetStepUp
      ) {
        updateSession({ redirectUrl });
        router.push(StepUpRoutes.STEP_UP);
      } else {
        clearSessionState();
        window.location.href = redirectUrl;
      }
    } else {
      publishEvent('FailedLogin', elementId, options?.extraData);
      router.push(CommonRoutes.ERROR);
    }
  };
};
